import React, { useEffect, useState } from 'react';
import { LAUNCH_DATE } from '../config/siteConfig';

const getTimeLeft = () => {
  const diff = LAUNCH_DATE.getTime() - Date.now();
  if (diff <= 0) return null;
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
};

const Unit = ({ value, label, compact }) => (
  <div className={`flex flex-col items-center ${compact ? 'min-w-[36px]' : 'min-w-[48px]'}`}>
    <span className={`font-bold text-gray-900 tabular-nums ${compact ? 'text-lg' : 'text-2xl'}`}>
      {String(value).padStart(2, '0')}
    </span>
    <span className={`text-amber-700 uppercase tracking-wide ${compact ? 'text-[9px]' : 'text-[10px]'}`}>
      {label}
    </span>
  </div>
);

const glassStyles = 'bg-white rounded-lg shadow-lg';

const CountdownTimer = ({ compact = false, className = '' }) => {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft);

  useEffect(() => {
    const id = setInterval(() => setTimeLeft(getTimeLeft()), 1000);
    return () => clearInterval(id);
  }, []);

  if (!timeLeft) {
    return (
      <div className={`inline-flex items-center justify-center ${glassStyles} px-4 py-2 ${className}`}>
        <span className="text-sm font-bold text-amber-800 drop-shadow-sm">We&apos;re Live!</span>
      </div>
    );
  }

  return (
    <div
      className={`inline-flex flex-col items-center ${glassStyles} ${
        compact ? 'px-3 py-2 gap-1' : 'px-5 py-3 gap-2'
      } ${className}`}
    >
      <p
        className={`font-semibold text-gray-600 uppercase tracking-widest ${
          compact ? 'text-[10px]' : 'text-xs'
        }`}
      >
        Launch Countdown
      </p>
      <div className="flex items-center gap-2 sm:gap-3">
        <Unit value={timeLeft.days} label="Days" compact={compact} />
        <span className="text-amber-600 font-bold pb-3">:</span>
        <Unit value={timeLeft.hours} label="Hrs" compact={compact} />
        <span className="text-amber-600 font-bold pb-3">:</span>
        <Unit value={timeLeft.minutes} label="Min" compact={compact} />
        <span className="text-amber-600 font-bold pb-3">:</span>
        <Unit value={timeLeft.seconds} label="Sec" compact={compact} />
      </div>
    </div>
  );
};

export default CountdownTimer;
